import { createStore } from 'vuex'
import { auth } from './auth-module'
import { helperModule } from './helper-module'
import { FSoalModule } from './cbt/f-soal-module'
import { FtTesModule } from './cbt/ft-tes-module'
import { survey } from './survey-module'
import {potensi} from "@/store/potensi-module";
export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    helperModule,
    FSoalModule,
    FtTesModule,
    survey,
    potensi
  }
})
